import { createFileRoute, Outlet } from "@tanstack/react-router"
import { useFlags } from "~/features/feature-flags"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { Module } from "~/components/design-system/pages"
import NotFound from "~/components/reusable/NotFound"

export const Route = createFileRoute("/_auth/procurement/order-suggestions/_layout")({
  component: RouteComponent,
})

function RouteComponent() {
  const { orderSuggestionsPage: orderSuggestionsPageFlag } = useFlags()

  if (orderSuggestionsPageFlag === false) {
    return <NotFound />
  }

  return (
    <Module breadcrumb={<BreadcrumbWrapper />}>
      <Outlet />
    </Module>
  )
}
